import { useEffect } from 'react'
import { useNavigate } from 'react-router-dom'
import { getInfoUser } from '../../../api/User'

const AuthRedirect = () => {
  const navigate = useNavigate()

  useEffect(() => {
    const fetchUser = async () => {
      const urlParams = new URLSearchParams(window.location.search)
      const token = urlParams.get('token')

      if (token) {
        localStorage.setItem('token', token)
        const user = await getInfoUser(token)
        console.log('user', user?.user)
        localStorage.setItem('userData', JSON.stringify(user?.user))
        navigate('/')
      }
    }
    fetchUser()
  }, [navigate])

  return (
    <div>
      <p>Redirection en cours...</p>
    </div>
  )
}

export default AuthRedirect
